import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiDelete, apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { IInspectorsResponse } from '../interfaces/IInspectorsResponse';
import { IInspectorUpdate } from '../interfaces/IInspector';

export async function fetchKnmInspectors(knoId?: string): Promise<IInspectorsResponse> {
  const params = new URLSearchParams();

  knoId && params.append('knoId', knoId);

  return apiGet<IInspectorsResponse>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/knm-inspectors?${params}`,
  );
}

export async function fetchKnmInspectorsUpdate(
  data: Omit<IInspectorsResponse, 'inspectors'> & { inspectors: IInspectorUpdate[] },
): Promise<IInspectorsResponse> {
  return apiPost<IInspectorsResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/knm-inspectors`,
    body: data,
  });
}

export async function deleteAuthorized(id: number): Promise<IInspectorsResponse> {
  return apiDelete<IInspectorsResponse>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/knm-inspectors/${id}`);
}
